<template>
  <div>
    <!-- Chart container -->
    <div
      ref="chartRef"
      style="width: 1100px; height: 400px;"
    />
  </div>
</template>

<script setup>
import * as echarts from 'echarts'
import { defineProps, onMounted, onUnmounted, ref, watch } from 'vue'

// Define props for dynamic data
const props = defineProps({
  chartTitle: {
    type: String,
    required: true,
  },
  chartLegend: {
    type: Array,
    default: () => ['Series 1', 'Series 2'],
  },
  chartCategories: {
    type: Array,
    required: true,
  },
  chartData: {
    type: Array,
    required: true,
  },
})

const chartRef = ref(null) // Reference for the chart container
let chartInstance = null

const initChart = () => {
  if (chartInstance) {
    chartInstance.dispose()
  }

  const chartDom = chartRef.value // Get the chart container DOM element
  if (chartDom) {
    chartInstance = echarts.init(chartDom)

    // Define chart options dynamically based on props
    const option = {
      title: {
        text: props.chartTitle,
        left: 'center',
      },
      tooltip: {
        trigger: 'axis',
      },
      legend: {
        data: props.chartLegend,
        top: '10%',
      },
      grid: {
        left: '3%',
        right: '4%',
        bottom: '3%',
        containLabel: true,
      },
      xAxis: {
        type: 'category',
        boundaryGap: false,
        data: props.chartCategories, // Use dynamic categories
        inverse: false,
      },
      yAxis: {
        type: 'value',
      },
      series: props.chartData.map(item => ({
        name: item.name,
        type: 'line',
        stack: 'Total',
        data: item.data,
      })),
    }

    chartInstance.setOption(option)

    // Resize chart on window resize
    window.addEventListener('resize', chartInstance.resize)
  }
}

// Initialize chart on component mount
onMounted(initChart)

// Cleanup chart instance and event listeners on unmount
onUnmounted(() => {
  if (chartInstance) {
    window.removeEventListener('resize', chartInstance.resize)
    chartInstance.dispose()
  }
})

// Watch for changes in data and reinitialize the chart
watch([() => props.chartData, () => props.chartCategories, () => props.chartLegend], initChart)
</script>

<style scoped>
/* Optional: Add custom styling */
</style>
